const POINTS = [
  {
    icon: 'ri-award-line',
    en: 'Proven Quality Standards',
    ar: 'معايير جودة مثبتة',
    desc: 'Consistent quality products through rigorous supply chain management and trusted sourcing.',
    descAr: 'منتجات ذات جودة ثابتة من خلال إدارة سلسلة توريد صارمة ومصادر موثوقة.',
  },
  {
    icon: 'ri-shield-check-line',
    en: 'Trusted Regional Partner',
    ar: 'شريك إقليمي موثوق',
    desc: 'Over 500 clients trust us across Oman, UAE, Saudi Arabia, Kuwait, Bahrain, and Qatar.',
    descAr: 'يثق بنا أكثر من 500 عميل في عُمان والإمارات والسعودية والكويت والبحرين وقطر.',
  },
  {
    icon: 'ri-truck-line',
    en: 'Reliable Bulk Supply',
    ar: 'توريد بالجملة موثوق',
    desc: 'Consistent stock availability for 1,000 to 50,000+ box orders. Supply contracts available.',
    descAr: 'توفر ثابت للمخزون لطلبات تتراوح بين 1000 و50000 صندوق وأكثر. عقود التوريد متاحة.',
  },
  {
    icon: 'ri-map-pin-line',
    en: 'Oman-Based Operations',
    ar: 'عمليات مقرها عُمان',
    desc: 'Physically based in Oman — fast delivery across Muscat, Salalah, Sohar, and beyond.',
    descAr: 'مقرنا في عُمان — توصيل سريع عبر مسقط وصلالة وصحار وغيرها.',
  },
  {
    icon: 'ri-customer-service-2-line',
    en: '24hr WhatsApp Response',
    ar: 'استجابة عبر واتساب خلال 24 ساعة',
    desc: 'Direct WhatsApp access to our team. Get pricing, samples, and quotes within 24 hours.',
    descAr: 'تواصل مباشر عبر واتساب. احصل على الأسعار والعينات وعروض الأسعار خلال 24 ساعة.',
  },
  {
    icon: 'ri-leaf-line',
    en: 'All Glove Types Covered',
    ar: 'تغطية لجميع أنواع القفازات',
    desc: 'Vinyl, latex, nitrile — medical, food, industrial, lab grades. One supplier for all your needs.',
    descAr: 'فينيل ولاتكس ونيتريل — درجات طبية وغذائية وصناعية ومختبرية. مورد واحد لجميع احتياجاتك.',
  },
];

export default function What28YearsMeans() {
  return (
    <section className="section-padding bg-navy">
      <div className="container-max">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/40 text-brand-green text-sm font-semibold px-5 py-2 rounded-full mb-5">
            🏅 Why Choose Us
          </span>
          <h2 className="font-heading font-bold text-white text-3xl md:text-4xl mb-2">
            Why omandisposables.com
          </h2>
          <p className="font-arabic text-white/85 text-2xl md:text-3xl font-bold" dir="rtl">
            لماذا omandisposables.com
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {POINTS.map((point, i) => (
            <div
              key={i}
              className="bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 hover:border-brand-green/30 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-green/15 mb-4">
                <i className={`${point.icon} text-2xl text-brand-green`} />
              </div>
              <h3 className="font-heading font-bold text-white text-base mb-1">{point.en}</h3>
              <p className="font-arabic text-white/80 text-sm text-right mb-3" dir="rtl">{point.ar}</p>
              <p className="text-white/85 text-sm leading-relaxed">{point.desc}</p>
              <p className="font-arabic text-white/75 text-xs text-right mt-2 leading-relaxed" dir="rtl">{point.descAr}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
